import React, { useState, useEffect } from 'react';
import api from '../services/api';
import useWindowWidth from '../hooks/useWindowWidth';
import { swalSuccess, swalError } from '../utils/alert';
import './ExpenseForm.css';
import './RevenueDesktop.css';

function CreditCardForm({ creditCard, onSuccess }) {
  const [formData, setFormData] = useState(
    creditCard
      ? { ...creditCard, bank_account_id: creditCard.bank_account_id || '' }
      : {
          name: '',
          bank_id: '',
          brand: '',
          last_four_digits: '',
          limit: 0,
          available_limit: 0,
          closing_day: 1,
          due_day: 1,
          bank_account_id: '',
          status: 'Ativo',
          color: '#000000',
        }
  );
  const [banks, setBanks] = useState([]);
  const width = useWindowWidth();
  const isMobile = width < 768;

  const statusOptions = [
    { id: 'Ativo', label: 'Ativo', color: 'success' },
    { id: 'Inativo', label: 'Inativo', color: 'danger' },
    { id: 'Bloqueado', label: 'Bloqueado', color: 'warning' },
  ];

  useEffect(() => {
    api.get('/banks')
      .then(response => {
        setBanks(response.data);
      })
      .catch(error => {
        console.error('Houve um erro ao buscar os bancos!', error);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleStatusClick = (status) => {
    setFormData({ ...formData, status });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const method = creditCard ? 'put' : 'post';
    const url = creditCard
      ? `/credit-cards/${creditCard.id}`
      : '/credit-cards';

    api[method](url, formData)
      .then(() => {
        swalSuccess('Cartão de Crédito salvo com sucesso!');
        onSuccess();
      })
      .catch(error => {
        console.error('Houve um erro ao salvar o cartão de crédito!', error);
        swalError('Erro ao salvar cartão de crédito.');
      });
  };

  // ════════════════════════════════════
  // MOBILE FORM
  // ════════════════════════════════════
  const renderMobileForm = () => (
    <form onSubmit={handleSubmit} className="expense-form-mobile" autoComplete="off">

      {/* Nome */}
      <div className="form-section">
        <label className="section-label">Nome do Cartão</label>
        <input
          type="text"
          className="form-control form-control-lg"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Ex: Nubank, Itaú..."
          required
        />
      </div>

      {/* Banco + Bandeira */}
      <div className="form-section">
        <div className="row g-2">
          <div className="col-7">
            <label className="section-label">Banco</label>
            <select className="form-select" name="bank_id" value={formData.bank_id} onChange={handleChange} required>
              <option value="">Selecionar</option>
              {banks.map(bank => <option key={bank.id} value={bank.id}>{bank.name}</option>)}
            </select>
          </div>
          <div className="col-5">
            <label className="section-label">Bandeira</label>
            <input
              type="text"
              className="form-control"
              name="brand"
              value={formData.brand}
              onChange={handleChange}
              placeholder="Visa, Master..."
              required
            />
          </div>
        </div>
      </div>

      {/* Últimos 4 dígitos + Cor */}
      <div className="form-section">
        <div className="row g-2">
          <div className="col-7">
            <label className="section-label">Últimos 4 dígitos</label>
            <input
              type="text"
              className="form-control"
              name="last_four_digits"
              value={formData.last_four_digits}
              onChange={handleChange}
              maxLength="4"
              placeholder="0000"
              required
            />
          </div>
          <div className="col-5">
            <label className="section-label">Cor</label>
            <input
              type="color"
              className="form-control form-control-color w-100"
              name="color"
              value={formData.color}
              onChange={handleChange}
              required
              style={{ height: '48px' }}
            />
          </div>
        </div>
      </div>

      {/* Limite + Conta Associada */}
      <div className="form-section">
        <div className="row g-2">
          <div className="col-5">
            <label className="section-label">Limite (R$)</label>
            <input
              type="number"
              step="0.01"
              className="form-control"
              name="limit"
              value={formData.limit}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-7">
            <label className="section-label">Conta Associada</label>
            <select className="form-select" name="bank_account_id" value={formData.bank_account_id} onChange={handleChange} required>
              <option value="">Selecionar</option>
              {banks.map(bank => <option key={bank.id} value={bank.id}>{bank.name}</option>)}
            </select>
          </div>
        </div>
      </div>

      {/* Dia Fechamento + Dia Vencimento */}
      <div className="form-section">
        <div className="row g-2">
          <div className="col-6">
            <label className="section-label">Dia Fechamento</label>
            <input
              type="number"
              className="form-control"
              name="closing_day"
              value={formData.closing_day}
              onChange={handleChange}
              min="1"
              max="31"
              required
            />
          </div>
          <div className="col-6">
            <label className="section-label">Dia Vencimento</label>
            <input
              type="number"
              className="form-control"
              name="due_day"
              value={formData.due_day}
              onChange={handleChange}
              min="1"
              max="31"
              required
            />
          </div>
        </div>
      </div>

      {/* Status */}
      <div className="form-section">
        <label className="section-label">Status</label>
        <div className="status-buttons">
          {statusOptions.map(s => (
            <button
              type="button"
              key={s.id}
              className={`status-btn ${s.color} ${formData.status === s.id ? 'active' : ''}`}
              onClick={() => handleStatusClick(s.id)}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mobile-form-footer">
        <button type="submit" className="btn btn-primary btn-lg w-100">
          Salvar Cartão de Crédito
        </button>
      </div>
    </form>
  );

  // ════════════════════════════════════
  // DESKTOP FORM
  // ════════════════════════════════════
  const renderDesktopForm = () => (
    <form onSubmit={handleSubmit} className="rv-form-desktop">

      {/* Nome + Bandeira */}
      <div className="rv-form-grid-2">
        <div className="rv-form-field">
          <label className="rv-form-label" htmlFor="name">Nome do Cartão</label>
          <input type="text" className="rv-form-input" id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Ex: Nubank, Itaú..." required />
        </div>
        <div className="rv-form-field">
          <label className="rv-form-label" htmlFor="brand">Bandeira</label>
          <input type="text" className="rv-form-input" id="brand" name="brand" value={formData.brand} onChange={handleChange} placeholder="Visa, Mastercard..." required />
        </div>
      </div>

      {/* Banco + Conta Associada */}
      <div className="rv-form-grid-2">
        <div className="rv-form-field">
          <label className="rv-form-label" htmlFor="bank_id">Banco</label>
          <select className="rv-form-select" id="bank_id" name="bank_id" value={formData.bank_id} onChange={handleChange} required>
            <option value="">Selecionar Banco</option>
            {banks.map(bank => <option key={bank.id} value={bank.id}>{bank.name}</option>)}
          </select>
        </div>
        <div className="rv-form-field">
          <label className="rv-form-label" htmlFor="bank_account_id">Conta Associada (para filtro)</label>
          <select className="rv-form-select" id="bank_account_id" name="bank_account_id" value={formData.bank_account_id} onChange={handleChange} required>
            <option value="">Selecionar Conta Bancária</option>
            {banks.map(bank => <option key={bank.id} value={bank.id}>{bank.name} - {bank.account_number}</option>)}
          </select>
        </div>
      </div>

      {/* Últimos 4 dígitos + Limite + Cor */}
      <div className="rv-form-grid-3">
        <div className="rv-form-field">
          <label className="rv-form-label" htmlFor="last_four_digits">Últimos 4 dígitos</label>
          <input type="text" className="rv-form-input" id="last_four_digits" name="last_four_digits" value={formData.last_four_digits} onChange={handleChange} maxLength="4" placeholder="0000" required />
        </div>
        <div className="rv-form-field">
          <label className="rv-form-label" htmlFor="limit">Limite (R$)</label>
          <input type="number" step="0.01" className="rv-form-input" id="limit" name="limit" value={formData.limit} onChange={handleChange} required />
        </div>
        <div className="rv-form-field">
          <label className="rv-form-label" htmlFor="color">Cor</label>
          <input type="color" className="rv-form-input" id="color" name="color" value={formData.color} onChange={handleChange} required style={{ height: '40px', padding: '0.25rem' }} />
        </div>
      </div>

      {/* Dia Fechamento + Dia Vencimento */}
      <div className="rv-form-grid-2">
        <div className="rv-form-field">
          <label className="rv-form-label" htmlFor="closing_day">Dia de Fechamento</label>
          <input type="number" className="rv-form-input" id="closing_day" name="closing_day" value={formData.closing_day} onChange={handleChange} min="1" max="31" required />
        </div>
        <div className="rv-form-field">
          <label className="rv-form-label" htmlFor="due_day">Dia de Vencimento</label>
          <input type="number" className="rv-form-input" id="due_day" name="due_day" value={formData.due_day} onChange={handleChange} min="1" max="31" required />
        </div>
      </div>

      {/* Status */}
      <div className="rv-form-field-full">
        <label className="rv-form-label">Status</label>
        <div className="rv-status-group">
          {statusOptions.map(s => (
            <button
              type="button"
              key={s.id}
              className={`rv-status-toggle ${formData.status === s.id ? `active-${s.color}` : ''}`}
              onClick={() => handleStatusClick(s.id)}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>

      <div className="rv-form-footer">
        <button type="submit" className="rv-btn-submit">Salvar Cartão de Crédito</button>
      </div>
    </form>
  );

  return isMobile ? renderMobileForm() : renderDesktopForm();
}

export default CreditCardForm;
